import { defineStyleConfig } from '@chakra-ui/react';
export const NavItem = defineStyleConfig({
  // The styles all Cards have in common
  baseStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    px: 3,
    py: 2,
    borderRadius: 6,
    _hover: {
      color: 'accent.darkest',
      bg: 'accent.lightest',
    },
  },
  variants: {
    default: {
      color: 'action.darkest',
      fontFamily: 'Kanit',
      fontSize: 'md',
      _hover: {
        bg: 'accent.lightest',
      },
    },
    selected: {
      color: 'accent.default',
      fontFamily: 'Kanit',
      fontSize: 'md',
      background: 'accent.default',
      bg: 'transparent',
      _hover: {
        bg: 'accent.lightest',
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
});
